import React from 'react';
import PropTypes from 'prop-types';

export function Button({ type, color, className, ...props }) {
  const classes = `px-5 py-3 text-center text-${color}-800 bg-${color}-100 hover:bg-${color}-200 hover:text-${color}-900 rounded-md ${className}`;

  // eslint-disable-next-line react/button-has-type
  return <button type={type} className={classes} {...props} />;
}

Button.propTypes = {
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  color: PropTypes.oneOf(['gray', 'red', 'orange', 'yellow', 'green', 'teal', 'blue', 'indigo', 'purple', 'pink']),
  className: PropTypes.string,
};

Button.defaultProps = {
  type: 'button',
  color: 'indigo',
  className: null,
};
